import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { RENOVATION_SAFEGUARD_LOGO_PATH, RENOVATION_SAFEGUARD_BRAND_NAME } from "@handshake/core-types";

@Component({
  selector: "core-renovation-safeguard-logo",
  standalone: true,
  imports: [CommonModule],
  template: `
    <img
      [src]="src"
      [alt]="alt"
      class="block w-auto max-w-full object-contain object-left"
      [style.height.px]="height"
    />
  `,
})
export class CoreRenovationSafeguardLogoComponent {
  @Input() src = RENOVATION_SAFEGUARD_LOGO_PATH;
  @Input() alt = `${RENOVATION_SAFEGUARD_BRAND_NAME} safety icon`;
  @Input() height = 36;
}
